export function assignLocation(target: string): void {
  window.location.assign(target);
}

export function reloadLocation(): void {
  window.location.reload();
}

